import { inject, Service } from '@angular/core';
import { HlmDialogService } from '@spartan-ng/helm/dialog';

@Service()
export class GlobalService {
    private readonly dialogService = inject(HlmDialogService);

    showModal<TResult = unknown, TContext = unknown>(component: any,
    context?: TContext,
    options?: { contentClass?: string; showCloseButton?: boolean, disableClose?:boolean}
    ) {
        return this.dialogService.open<TResult, TContext>(component, {
            context,
            ...options,
        });
    }

}
